import React from 'react';
interface LinkedInMarkProps {
  className?: string;
}

/** Filled LinkedIn brand glyph. */
export function LinkedInMark({
  className
}: LinkedInMarkProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-141" data-mp="2qqwsh3m067k2">
      <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zm1.78 13.02H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" data-id="element-142" data-mp="2lvhf0crwqdo6" />
    </svg>;
}